<template lang="pug">
.iframe_container
  vue-friendly-iframe(:src="link", @load="onLoad", ref="friendlyIframe", allowfullscreen="allowfullscreen")
</template>
<script>
import Breadcrumb from "@/components/common/Breadcrumb";
import { stopScroll, startScroll } from "@/utils/scroll";

export default {
  name: "Game",
  components: {
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      link: "https://www.game.topbasketball.com.tw/",
    };
  },
  watch: {
    "$route.query.id"() {},
  },
  mounted() {
    stopScroll();
  },
  created() {},
  destroyed() {
    startScroll();
  },
  methods: {
    onLoad() {},
  },
};
</script>

<style scoped lang="scss">
::v-deep .vue-friendly-iframe > iframe {
  width: 100%;
  height: 100vh;
}
</style>
